import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { RootLayout } from "@/components/layout/RootLayout";
import HomePage from "@/pages/HomePage";

/**
 * La home est importée directement : c'est la première page vue, elle ne doit
 * pas attendre un second aller-retour réseau. Le reste est chargé à la demande,
 * ce qui garde le bundle initial léger — le hero et ses faisceaux sont ce qui
 * doit apparaître vite.
 */
const LocationPage = lazy(() => import("@/pages/LocationPage"));
const ShopPage = lazy(() => import("@/pages/ShopPage"));
const ServicesPage = lazy(() => import("@/pages/ServicesPage"));
const CartPage = lazy(() => import("@/pages/CartPage"));
const CheckoutPage = lazy(() => import("@/pages/CheckoutPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function PageFallback() {
  return (
    <div className="container py-44">
      <div className="h-64 animate-pulse rounded-2xl bg-surface" />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route index element={<HomePage />} />
        <Route
          path="/location"
          element={
            <Suspense fallback={<PageFallback />}>
              <LocationPage />
            </Suspense>
          }
        />
        <Route
          path="/shop"
          element={
            <Suspense fallback={<PageFallback />}>
              <ShopPage />
            </Suspense>
          }
        />
        <Route
          path="/services"
          element={
            <Suspense fallback={<PageFallback />}>
              <ServicesPage />
            </Suspense>
          }
        />
        <Route
          path="/panier"
          element={
            <Suspense fallback={<PageFallback />}>
              <CartPage />
            </Suspense>
          }
        />
        <Route
          path="/commande"
          element={
            <Suspense fallback={<PageFallback />}>
              <CheckoutPage />
            </Suspense>
          }
        />
        <Route
          path="/contact"
          element={
            <Suspense fallback={<PageFallback />}>
              <ContactPage />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={<PageFallback />}>
              <NotFoundPage />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
